import { CAPSTONE } from '@rsos/constants/appNames';
import { SinatraState } from '@rsos/sinatra';

export const organizationSelector = (state: { sinatra: SinatraState }) => {
  return state.sinatra.user.profile?.organizations.find(
    org => !!org.roles.find(role => role.application === CAPSTONE),
  );
};
